import {apollo} from "@/apollo";
import gql from "graphql-tag";
import Activity, {WriteActivity} from "@/models/activity";
import utils from "@/services/utils";
import {eventBus} from "@/services/event-bus";

class ActivityService {
    async activities() {
        let promise = await apollo.query({
            query: gql`query {
                activities {
                    id
                    code
                    name
                    description
                    availability {
                        availability
                        periodOccupancy {
                            periodId
                            occupancy
                        }
                    }
                }
            }`
        });
        return promise.data.activities;
    }

    async activityById(activityId: number) {
        let promise = await apollo.query({
            query: gql`query($activityId: Int!) {
                activityById(activityId: $activityId){
                    id
                    code
                    name
                    description
                }
            }`,
            variables: {activityId: activityId}
        });
        return promise.data.activityById;
    }

    async createActivity(activity: Activity) {
        const wa = new WriteActivity({
            id: 0,
            code: activity.code,
            name: activity.name,
            description: activity.description
        });
        try {
            let promise = await apollo.mutate(
                {
                    mutation: gql`mutation($writeActivity: WriteActivity!) {
                        createActivity(writeActivity: $writeActivity)
                    }`, variables: {writeActivity: wa}
                }
            );
            return promise.data;
        } catch (e:any) {
            eventBus.$emit('error', e.message);
            throw e;
        }
    }

    async updateActivity(activity: Activity) {
        if (utils.isNull(activity.id)) {
            return false;
        }
        const wa = new WriteActivity({
            id: activity.id,
            code: activity.code,
            name: activity.name,
            description: activity.description
        });
        try {
            let promise = await apollo.mutate(
                {
                    mutation: gql`mutation($writeActivity: WriteActivity!) {
                        updateActivity(writeActivity: $writeActivity)
                    }`, variables: {writeActivity: wa}
                }
            );
            return promise.data;
        } catch (e:any) {
            eventBus.$emit('error', e.message);
            throw e;
        }
    }
}

export default new ActivityService();
